export default __webpack_public_path__ + "static/media/webinar.e31ef77d.jpeg";